export function transliterate(text) {
  const cyr = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "yo",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "h",
    ц: "ts",
    ч: "ch",
    ш: "sh",
    щ: "sch",
    ъ: "'",
    ы: "y",
    ь: "'",
    э: "e",
    ю: "yu",
    я: "ya",
    " ": "_",
    _: "_",
    ".": "-",
    ",": "-",
  };

  return text
    .toLowerCase()
    .split("")
    .map((char) => {
      return cyr[char] || char;
    })
    .join("");
}
